/* eslint-disable no-restricted-globals */
/* eslint-disable array-callback-return */
import { Box, Grid } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, Checkbox, FormControl, FormControlLabel, InputAdornment, InputLabel, MenuItem, Select, Switch, TextField, Typography } from '@mui/material';
import { getClientRelocationPoliciesByClientId, postClientRelocationPolicy, updateClientRelocationPolicy } from 'modules/clients/clients.actions';
import { GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_FAILURE, UPDATE_CLIENT_RELO_POLICY_FAILURE } from 'modules/clients/types';
import SpinnerComponent from 'modules/common/spinner.component';
import { showToast } from 'modules/layout/layout.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { ExpandMore } from '@mui/icons-material';
import { formatDateForInput } from 'utilities/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ServiceBenefitDetails = ({ staticService, dynamicService, setDynamicServiceDetails, policyDetails }) => {
    const [isOpen, setIsOpen] = useState(false);
    const numQuestions = staticService.staticPolicyBenefits.map((benefit) => benefit.staticPolicyBenefitOptions.length).reduce((a, b) => a + b, 0);
    const primaryStaticBenefit = staticService.staticPolicyBenefits.find((benefit) => benefit.staticPolicyBenefit.benefitTypeId === '7237738f-fddd-4ed3-a281-3ddcc4b7e2b1');

    const setServiceActive = (isActive) => {
        if (isActive) {
            let updatedBenefits = [];

            staticService.staticPolicyBenefits.forEach((staticBenefit) => {
                let updateBenefitOptions = [];
                staticBenefit.staticPolicyBenefitOptions.forEach((staticOption) => {
                    updateBenefitOptions.push({
                        policyBenefitOptionId: undefined,
                        policyBenefitId: undefined,
                        staticPolicyBenefitOptionId: staticOption.staticPolicyBenefitOptionId,
                        optionValue: '',
                        addedBy: 1, // TODO: Replace with actual user id
                        addedOn: new Date(),
                        modifiedBy: 1, // TODO: Replace with actual user id
                        modifiedOn: new Date()
                    });
                });

                updatedBenefits.push({
                    policyBenefit: {
                        policyBenefitId: undefined,
                        policyServiceId: undefined,
                        staticPolicyBenefitId: staticBenefit.staticPolicyBenefit.staticPolicyBenefitId,
                        isActive: false,
                        addedBy: 1, // TODO: Replace with actual user id
                        addedOn: new Date(),
                        modifiedBy: 1, // TODO: Replace with actual user id
                        modifiedOn: new Date()
                    },
                    policyBenefitOptions: updateBenefitOptions,
                });
            });

            let updatedService = {
                policyService: {
                    policyServiceId: undefined,
                    clientRelocationPolicyId: policyDetails.policy.relocationPolicyId, 
                    staticPolicyServiceId: staticService.staticPolicyService.staticPolicyServiceId,
                    isActive: true,
                    addedBy: 1, // TODO: Replace with actual user id
                    addedOn: new Date(),
                    modifiedBy: 1, // TODO: Replace with actual user id
                    modifiedOn: new Date()
                },
                policyBenefits: updatedBenefits
            }

            setDynamicServiceDetails(updatedService);
        } else {
            let updatedService = { ...dynamicService };
            updatedService.policyService.isActive = false;
            setDynamicServiceDetails(updatedService);
        }
    }

    const setBenefitActive = (dynamicBenefit, isActive) => {
        let updatedService = { ...dynamicService };

        const benefitToUpdateIndex = updatedService.policyBenefits.findIndex((benefit) => benefit.policyBenefit.staticPolicyBenefitId === dynamicBenefit.policyBenefit.staticPolicyBenefitId);
        
        updatedService.policyBenefits[benefitToUpdateIndex].policyBenefit.isActive = isActive;
        setDynamicServiceDetails(updatedService);
    }

    const setDynamicBenefitOption = (dynamicBenefitOption, staticBenefitOption, newValue) => {
        let updatedService = { ...dynamicService };

        const benefitToUpdate = updatedService.policyBenefits.find((benefit) => benefit.policyBenefit.staticPolicyBenefitId === staticBenefitOption.staticPolicyBenefitId);
        const benefitToUpdateIndex = updatedService.policyBenefits.findIndex((benefit) => benefit.policyBenefit.staticPolicyBenefitId === staticBenefitOption.staticPolicyBenefitId);
        const optionToUpdate = benefitToUpdate.policyBenefitOptions.find((option) => option.staticPolicyBenefitOptionId === dynamicBenefitOption.staticPolicyBenefitOptionId);
        const optionToUpdateIndex = benefitToUpdate.policyBenefitOptions.findIndex((option) => option.staticPolicyBenefitOptionId === dynamicBenefitOption.staticPolicyBenefitOptionId);

        if (staticBenefitOption.benefitOptionTypeId === 'ae1ce5d9-667a-4f7f-aba4-9a1e36a2d9e2') {
            optionToUpdate.optionValue = newValue ? 'Yes' : 'No';
        } else {
            optionToUpdate.optionValue = newValue;
        }
        
        updatedService.policyBenefits[benefitToUpdateIndex].policyBenefitOptions[optionToUpdateIndex] = optionToUpdate;
        setDynamicServiceDetails(updatedService);
    }

    return (
        <Box sx={{ marginBottom: '5px' }}>
            <Card>
                <CardContent>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>{staticService.staticPolicyService.title} ({numQuestions} questions)</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Typography>Active</Typography>
                            <Switch
                                checked={dynamicService ? dynamicService.policyService.isActive : false}
                                // disabled={record.transferreeHasWebAccess}
                                onChange={(e) => setServiceActive(e.target.checked)}
                                value={dynamicService ? dynamicService.policyService.isActive : false}
                            />
                        </Box>
                    </Box>
                    {(dynamicService ? dynamicService.policyService.isActive : false) && (
                        <Accordion expanded={isOpen} onChange={()=> {setIsOpen(!isOpen);}} >
                            <AccordionSummary expandIcon={<Box><ExpandMore color="inherit" /></Box>}>
                                <Box>
                                    <Typography>View & Edit Questions</Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Box>
                                        {primaryStaticBenefit.staticPolicyBenefitOptions.map((option) => {
                                            const dynamicBenefitOption = dynamicService.policyBenefits.find((benefit) => benefit.policyBenefit.staticPolicyBenefitId === primaryStaticBenefit.staticPolicyBenefit.staticPolicyBenefitId).policyBenefitOptions.find((opt) => opt.staticPolicyBenefitOptionId === option.staticPolicyBenefitOptionId);
                                            return (
                                                <Box sx={{ backgroundColor: '#f5f5f5', padding: '10px', marginBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                    <Typography>{option.description}</Typography>
                                                    {option.benefitOptionTypeId === 'c09a77ba-5334-4d41-ba4c-10b5cee75cfc' && (
                                                        <Box>
                                                            <TextField
                                                                label=""
                                                                name="optionValue"
                                                                value={dynamicBenefitOption.optionValue}
                                                                margin="dense"
                                                                sx={{ maxWidth: '360px' }}
                                                                variant="standard"
                                                                type="number"
                                                                allowDecimal={false}
                                                                onChange={(e) => setDynamicBenefitOption(dynamicBenefitOption, option, e.target.value)}
                                                            />      
                                                        </Box>
                                                    )}
                                                    {option.benefitOptionTypeId === 'd325d8f6-d628-4379-85d9-4e38d59334ea' && (
                                                        <Box>
                                                            <TextField
                                                                label=""
                                                                name="optionValue"
                                                                value={dynamicBenefitOption.optionValue}
                                                                margin="dense"
                                                                sx={{ maxWidth: '360px' }}
                                                                variant="standard"
                                                                type="number"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                                                                }}
                                                                allowDecimal
                                                                onChange={(e) => setDynamicBenefitOption(dynamicBenefitOption, option, e.target.value)}
                                                            />      
                                                        </Box>
                                                    )}
                                                    {option.benefitOptionTypeId === 'ae1ce5d9-667a-4f7f-aba4-9a1e36a2d9e2' && (
                                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                            <Typography>{dynamicBenefitOption.optionValue}</Typography>
                                                            <Switch
                                                                checked={dynamicBenefitOption.optionValue === 'Yes'}
                                                                // disabled={record.transferreeHasWebAccess}
                                                                onChange={(e) => setDynamicBenefitOption(dynamicBenefitOption, option, e.target.checked)}
                                                                value={dynamicBenefitOption.optionValue === 'Yes'}
                                                            />
                                                        </Box>
                                                    )}
                                                </Box>
                                            )
                                        })}
                                    </Box>
                                    {staticService.staticPolicyBenefits.length > 1 && (
                                        <Box>
                                            <Typography>Sub-benefit Options</Typography>
                                            {staticService.staticPolicyBenefits.map((staticBenefit) => {
                                                if (staticBenefit.staticPolicyBenefit.benefitTypeId !== '7237738f-fddd-4ed3-a281-3ddcc4b7e2b1') {
                                                    const dynamicBenefit = dynamicService.policyBenefits.find((benefit) => benefit.policyBenefit.staticPolicyBenefitId === staticBenefit.staticPolicyBenefit.staticPolicyBenefitId);
                                                    return (
                                                        <Card>
                                                            <CardContent>
                                                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                                    <Box>
                                                                        <Typography>{staticBenefit.staticPolicyBenefit.title} ({staticBenefit.staticPolicyBenefitOptions.length} questions)</Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                        <Typography>Active</Typography>
                                                                        <Switch
                                                                            checked={dynamicBenefit.policyBenefit.isActive}
                                                                            // disabled={record.transferreeHasWebAccess}
                                                                            onChange={(e) => setBenefitActive(dynamicBenefit, e.target.checked)}
                                                                            value={dynamicBenefit.policyBenefit.isActive}
                                                                        />
                                                                    </Box>
                                                                </Box>
                                                                <Box>
                                                                    {staticBenefit.staticPolicyBenefitOptions.map((option) => {
                                                                        const dynamicBenefitOption = dynamicBenefit.policyBenefitOptions.find((opt) => opt.staticPolicyBenefitOptionId === option.staticPolicyBenefitOptionId);
                                                                        
                                                                        if (!(dynamicBenefitOption && dynamicBenefit.policyBenefit.isActive)) return null;

                                                                        return (
                                                                            <Box sx={{ backgroundColor: '#f5f5f5', padding: '10px', marginBottom: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                                                <Typography>{option.description}</Typography>
                                                                                {option.benefitOptionTypeId === 'c09a77ba-5334-4d41-ba4c-10b5cee75cfc' && (
                                                                                    <Box>
                                                                                        <TextField
                                                                                            label=""
                                                                                            name="optionValue"
                                                                                            value={dynamicBenefitOption.optionValue}
                                                                                            margin="dense"
                                                                                            sx={{ maxWidth: '360px' }}
                                                                                            variant="standard"
                                                                                            type="number"
                                                                                            allowDecimal={false}
                                                                                            onChange={(e) => setDynamicBenefitOption(dynamicBenefitOption, option, e.target.value)}
                                                                                        />      
                                                                                    </Box>
                                                                                )}
                                                                                {option.benefitOptionTypeId === 'd325d8f6-d628-4379-85d9-4e38d59334ea' && (
                                                                                    <Box>
                                                                                        <TextField
                                                                                            label=""
                                                                                            name="optionValue"
                                                                                            value={dynamicBenefitOption.optionValue}
                                                                                            margin="dense"
                                                                                            sx={{ maxWidth: '360px' }}
                                                                                            variant="standard"
                                                                                            type="number"
                                                                                            InputProps={{
                                                                                                startAdornment: <InputAdornment position="start">$</InputAdornment>
                                                                                            }}
                                                                                            allowDecimal
                                                                                            onChange={(e) => setDynamicBenefitOption(dynamicBenefitOption, option, e.target.value)}
                                                                                        />      
                                                                                    </Box>
                                                                                )}
                                                                                {option.benefitOptionTypeId === 'ae1ce5d9-667a-4f7f-aba4-9a1e36a2d9e2' && (
                                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                                                        <Typography>{dynamicBenefitOption.optionValue}</Typography>
                                                                                        <Switch
                                                                                            checked={dynamicBenefitOption.optionValue === 'Yes'}
                                                                                            // disabled={record.transferreeHasWebAccess}
                                                                                            onChange={(e) => setDynamicBenefitOption(dynamicBenefitOption, option, e.target.checked)}
                                                                                            value={dynamicBenefitOption.optionValue === 'Yes'}
                                                                                        />
                                                                                    </Box>
                                                                                )}
                                                                            </Box>
                                                                        )
                                                                    })}
                                                                </Box>
                                                            </CardContent>
                                                        </Card>
                                                    )
                                                }
                                            })}
                                        </Box>
                                    )}
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )}
                </CardContent>
            </Card>
        </Box>
    )
}

const ReloPolicyDetails = ({ policyDetails, clientDetails, clientBillingPolicies, clientPolicyStatuses, updateClientRelocationPolicy, getClientRelocationPoliciesByClientId, showToast, staticBenefits, policyAssignmentTypes, isHalfScreen, setIsPolicyFullScreen }) => {

  const [policyDescription, setPolicyDescription] = useState(policyDetails.policy.policyDescription || '');
  const [policyCap, setPolicyCap] = useState(policyDetails.policy.policyCap || 0);
  const [clientPolicyStatusId, setClientPolicyStatusId] = useState(policyDetails.policy.clientPolicyStatusId || '00000000-0000-0000-0000-000000000000');
  const [clientBillingPolicyId, setClientBillingPolicyId] = useState(policyDetails.policy.clientBillingPolicyId || 0);
    const [associatedDivisions, setAssociatedDivisions] = useState(String(policyDetails.policyDivisions?.[0]?.clientDivisionId ?? ''));

  const [policyAssignmentTypeId, setPolicyAssignmentTypeId] = useState(policyDetails.policy.policyAssignmentTypeId || '00000000-0000-0000-0000-000000000000');
  const [effectiveStart, setEffectiveStart] = useState(policyDetails.policy.effectiveStart || null);
  const [effectiveEnd, setEffectiveEnd] = useState(policyDetails.policy.effectiveEnd || null);
  const [isPolicyCapped, setIsPolicyCapped] = useState(policyDetails.policy.isPolicyCapped || false);
  const [isRepayAgreementRequired, setIsRepayAgreementRequired] = useState(policyDetails.policy.isRepayAgreementRequired || false);
  const [isCostEstimateRequired, setIsCostEstimateRequired] = useState(policyDetails.policy.isCostEstimateRequired || false);

  const [dynamicServices, setDynamicServices] = useState(policyDetails.policyServices || []);

  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const setDynamicServiceDetails = (updatedService) => {
    let updatedServices = [...dynamicServices];

    const serviceIndex = updatedServices.findIndex((service) => service.policyService.staticPolicyServiceId === updatedService.policyService.staticPolicyServiceId);
    if (serviceIndex === -1) {
        updatedServices.push(updatedService);
    } else {
        updatedServices[serviceIndex] = updatedService;
    }

    setDynamicServices(updatedServices);
    setIsDirty(true);
  }

  const savePolicy = async () => {
    const selectedDivision = clientDetails?.clientDivisions?.find(division => String(division.clientDivisionId) === associatedDivisions);
    if (associatedDivisions && !selectedDivision) {
        showToast('Selected division is no longer available.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        return false;
    }

    let newValues = { ...policyDetails, policy: { ...policyDetails.policy } };
    setIsLoading(true);

    newValues.policy.policyDescription = policyDescription;
    newValues.policy.policyCap = parseFloat(policyCap);
    newValues.policy.clientPolicyStatusId = clientPolicyStatusId;
    newValues.policy.clientBillingPolicyId = clientBillingPolicyId;
    newValues.policyDivisions = selectedDivision ? [selectedDivision] : [];
    newValues.policy.associatedDivisions = newValues.policyDivisions.map(division => division.clientDivisionId).join(',');
    newValues.policy.policyAssignmentTypeId = policyAssignmentTypeId;
    newValues.policy.effectiveStart = effectiveStart;
    newValues.policy.effectiveEnd = effectiveEnd;
    newValues.policy.isPolicyCapped = isPolicyCapped;
    newValues.policy.isRepayAgreementRequired = isRepayAgreementRequired;
    newValues.policy.isCostEstimateRequired = isCostEstimateRequired;

    newValues.policyServices = dynamicServices;

    const resp = await updateClientRelocationPolicy(newValues);
    if (resp.type === UPDATE_CLIENT_RELO_POLICY_FAILURE) {
        showToast('Failed to save policy, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
    } else {
        const getResp = await getClientRelocationPoliciesByClientId(policyDetails.policy.clientRecordId);
        if (getResp.type === GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_FAILURE) {
            setIsLoading(false);
            return false;
        } else {
            setIsLoading(false);
            setIsDirty(false);
            showToast('Successfully saved policy changes.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
            return true;
        }
    }
  }

  const deletePolicy = async () => {
    //   if (!confirm(`Are you sure you want to delete policy ${policyDetails.policy.relocationPolicyId}?`)) {
    //     return;
    //   }
      let statusId = policyDetails.policy.clientPolicyStatusId && policyDetails.policy.clientPolicyStatusId === clientPolicyStatuses.find(status => status.title === 'Active')?.id 
      ? clientPolicyStatuses.find(status => status.title === 'Inactive')?.id : clientPolicyStatuses.find(status => status.title === 'Active')?.id;
      setIsLoading(true);
            const newValues = {
                ...policyDetails,
                policy: {
                    ...policyDetails.policy,
                    clientPolicyStatusId: statusId
                }
            };
            const resp = await updateClientRelocationPolicy(newValues);
            if (resp.type === UPDATE_CLIENT_RELO_POLICY_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        const getResp = await getClientRelocationPoliciesByClientId(policyDetails.policy.clientRecordId);
        if (getResp.type === GET_CLIENT_RELO_POLICIES_BY_CLIENT_ID_FAILURE) {
          setIsLoading(false);
          return false;
        } else {
          setIsLoading(false);
          return true;
        }
      }
  };

  useEffect(() => {
    if (policyDetails) {
        setPolicyDescription(policyDetails.policy.policyDescription || '');
        setPolicyCap(policyDetails.policy.policyCap || 0);
        setClientPolicyStatusId(policyDetails.policy.clientPolicyStatusId || '00000000-0000-0000-0000-000000000000');
        setClientBillingPolicyId(policyDetails.policy.clientBillingPolicyId || 0);
        setAssociatedDivisions(String(policyDetails.policyDivisions?.[0]?.clientDivisionId ?? ''));
        setDynamicServices(policyDetails.policyServices || []);
        setPolicyAssignmentTypeId(policyDetails.policy.policyAssignmentTypeId || '00000000-0000-0000-0000-000000000000');
        setEffectiveStart(policyDetails.policy.effectiveStart || null);
        setEffectiveEnd(policyDetails.policy.effectiveEnd || null);
        setIsPolicyCapped(policyDetails.policy.isPolicyCapped || false);
        setIsRepayAgreementRequired(policyDetails.policy.isRepayAgreementRequired || false);
        setIsCostEstimateRequired(policyDetails.policy.isCostEstimateRequired || false);
        setIsDirty(false);
    }
  }, [policyDetails]);

  return (
    <Box sx={{ padding: '10px' }}>
        <Card sx={{ position: 'relative', width: '100%', flexGrow: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
            <Box>
                <CardContent sx={{ maxWidth: '100% !important', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontSize: '1.3125rem',
                            fontWeight: 'bold'
                        }}
                    >
                        Relo Policy {policyDetails.policy.relocationPolicyId}
                    </Typography>
                    {isHalfScreen && (
                        <Box sx={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={['fas', 'expand']} size="2x" onClick={() => setIsPolicyFullScreen(true)} />
                        </Box>
                    )}
                    {!isHalfScreen && (
                        <Box sx={{ cursor: 'pointer' }}>
                            <FontAwesomeIcon icon={['fas', 'xmark']} size="2x" onClick={() => setIsPolicyFullScreen(false)} />
                        </Box>
                    )}
                </CardContent>
                <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
                    <Grid container spacing={2} columns={{ xs: 3 }}>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <TextField
                                label="Relo Policy Code"
                                name="reloPolicyCode"
                                value={policyDetails.policy.policyCode || ''}
                                margin="dense"
                                sx={{ maxWidth: '360px' }}
                                variant="standard"
                                type="text"
                                disabled={true}
                            />
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <TextField
                                label="Relo Policy Description"
                                name="policyDescription"
                                value={policyDescription}
                                margin="dense"
                                sx={{ maxWidth: '360px' }}
                                variant="standard"
                                type="text"
                                onChange={(e) => { setPolicyDescription(e.target.value); setIsDirty(true); }}
                            />
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <TextField
                                label="Policy Cap"
                                name="policyCap"
                                value={policyCap}
                                margin="dense"
                                sx={{ maxWidth: '360px' }}
                                variant="standard"
                                type="number"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                                }}
                                allowDecimal
                                onChange={(e) => { setPolicyCap(e.target.value); setIsDirty(true); }}
                            />
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <FormControl sx={{ marginTop: '6px' }}>
                                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Relo Policy Status</InputLabel>
                                <Select
                                    label="Currency"
                                    name="clientPolicyStatusId"
                                    value={clientPolicyStatusId}
                                    variant="standard"
                                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                                    onChange={(e) => { setClientPolicyStatusId(e.target.value); setIsDirty(true); }}
                                >
                                    {clientPolicyStatuses.map(opt => (
                                        <MenuItem key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <FormControl sx={{ marginTop: '6px' }}>
                                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Billing Policy</InputLabel>
                                <Select
                                    label="Currency"
                                    name="clientBillingPolicyId"
                                    value={clientBillingPolicyId}
                                    variant="standard"
                                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                                    onChange={(e) => { setClientBillingPolicyId(e.target.value); setIsDirty(true); }}
                                >
                                    {clientBillingPolicies.map(opt => (
                                        <MenuItem key={opt.billingPolicy.billingPolicyId} value={opt.billingPolicy.billingPolicyId}>
                                            {opt.billingPolicy.billingPolicyDescription}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <FormControl sx={{ marginTop: '6px' }}>
                                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Divisions</InputLabel>
                                <Select
                                    label="Divisions"
                                    name="divisions"
                                    value={associatedDivisions}
                                    variant="standard"
                                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                                    onChange={(e) => { setAssociatedDivisions(e.target.value); setIsDirty(true); }} 
                                >
                                    {((clientDetails && clientDetails.clientDivisions) || []).map(division => (
                                        <MenuItem key={division.clientDivisionId} value={String(division.clientDivisionId)}>
                                            {division.divisionName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <FormControl sx={{ marginTop: '6px' }}>
                                <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }}>Policy Type</InputLabel>
                                <Select
                                    label=""
                                    name="policyAssignmentTypeId"
                                    value={policyAssignmentTypeId}
                                    variant="standard"
                                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                                    onChange={(e) => { setPolicyAssignmentTypeId(e.target.value); setIsDirty(true); }}
                                >
                                    {policyAssignmentTypes.map(opt => (
                                        <MenuItem key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <TextField
                                label="Effective Start"
                                name="effectiveStart"
                                value={formatDateForInput(effectiveStart)}
                                margin="dense"
                                sx={{ maxWidth: '360px' }}
                                variant="standard"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => { setEffectiveStart(e.target.value); setIsDirty(true); }}
                            />
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px' }}>
                            <TextField
                                label="Effective End"
                                name="effectiveEnd"
                                value={formatDateForInput(effectiveEnd)}
                                margin="dense"
                                sx={{ maxWidth: '360px' }}
                                variant="standard"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => { setEffectiveEnd(e.target.value); setIsDirty(true); }}
                            />
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px'}}>
                            <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                                <FormControlLabel
                                    key="isPolicyCapped"
                                    name="isPolicyCapped"
                                    labelPlacement="start"
                                    label="Policy Capped"
                                    control={
                                        <Checkbox
                                            checked={isPolicyCapped || false}
                                            onChange={(e) => { setIsPolicyCapped(e.target.checked); setIsDirty(true); }}
                                        />
                                    }
                                    sx={{ marginTop: '6px', minWidth: '90px' }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px'}}>
                            <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                                <FormControlLabel
                                    key="isRepayAgreementRequired"
                                    name="isRepayAgreementRequired"
                                    labelPlacement="start"
                                    label="Repay Agreement Required"
                                    control={
                                        <Checkbox
                                            checked={isRepayAgreementRequired || false}
                                            onChange={(e) => { setIsRepayAgreementRequired(e.target.checked); setIsDirty(true); }}
                                        />
                                    }
                                    sx={{ marginTop: '6px', minWidth: '90px' }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item md='4' sx={{ margin: '0 20px'}}>
                            <FormControl sx={{ marginTop: '-10px', marginBottom: '1px' }}>
                                <FormControlLabel
                                    key="isCostEstimateRequired"
                                    name="isCostEstimateRequired"
                                    labelPlacement="start"
                                    label="Cost Estimate Required"
                                    control={
                                        <Checkbox
                                            checked={isCostEstimateRequired || false}
                                            onChange={(e) => { setIsCostEstimateRequired(e.target.checked); setIsDirty(true); }}
                                        />
                                    }
                                    sx={{ marginTop: '6px', minWidth: '90px' }}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Box sx={{ marginTop: '20px'}}>
                        <Typography sx={{fontWeight: 'bold'}}>Benefit Options</Typography>
                        <Typography sx={{marginTop: '10px'}}>Toggle benefits on/off for this policy. Expand active benefits to view and edit questions.</Typography>
                    </Box>

                    <Box sx={{ marginTop: '20px' }}>
                        {staticBenefits.map((service) => {
                            return (
                                <ServiceBenefitDetails 
                                    staticService={service} 
                                    dynamicService={dynamicServices.find((dynService) => dynService.policyService.staticPolicyServiceId === service.staticPolicyService.staticPolicyServiceId)} 
                                    setDynamicServiceDetails={setDynamicServiceDetails} 
                                    policyDetails={policyDetails}
                                />
                            )
                        })}
                    </Box>

                    <Box sx={{ paddingLeft: '16px', display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '20px', justifyContent: 'flex-end' }}>
                        {!isLoading && (
                            <>
                                {clientPolicyStatusId === clientPolicyStatuses.find(status => status.title === 'Inactive')?.id && (
                                    <Button color="primary" onClick={deletePolicy} variant="outlined">
                                        Set Active
                                    </Button>
                                )}
                                {clientPolicyStatusId === clientPolicyStatuses.find(status => status.title === 'Active')?.id && (
                                    <Button color="primary" onClick={deletePolicy} variant="outlined">
                                        Set Inactive
                                    </Button>
                                )}
                                <Button color="primary" onClick={savePolicy} disabled={!isDirty} variant="contained">
                                    Save
                                </Button>
                            </>
                        )}
                        {isLoading && <SpinnerComponent/>}
                    </Box>
                </CardContent>
            </Box>
        </Card>
    </Box>
  );  
};

const mapStateToProps = state => {
    const { clientDetails } = state.clients.clientsInfo[state.clients.currentClientId];
  const { clientPolicyStatuses, policyAssignmentTypes } = state.enumerations.allEnums;
  const { staticBenefits } = state.clients;
  return {
    clientDetails,
    clientPolicyStatuses,
    staticBenefits,
    policyAssignmentTypes
  };
};
  
export default compose(
  connect(mapStateToProps, {
    getClientRelocationPoliciesByClientId,
    postClientRelocationPolicy,
    updateClientRelocationPolicy,
    showToast
  }),
)(ReloPolicyDetails);